import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import { SickLeaveDetail } from './sickDetails';
import { Observable } from 'rxjs/Observable';
import { CONFIGURATION } from '../app.config';


@Injectable()
export class SickLeaveService {
    private _sickLeaveServiceReportUrl = CONFIGURATION.baseServiceUrl + 'sickleavereport/';
    private _ssnUrl = CONFIGURATION.baseServiceUrl + 'SsnInfo/';

    constructor(private _http: Http) { }

    getCGData(): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(this._sickLeaveServiceReportUrl + 'getsickleavecontrolgroup', { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }

    getSSNData(CG: any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(this._sickLeaveServiceReportUrl + `getsickleavessnbycontrolgroup?ControlGroup=${CG}`,
            { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }

    getallEINlist(CG: any, ssn: any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(this._sickLeaveServiceReportUrl +
            `getsickleaveeinbycontrolgroupandssn?ControlGroup=${CG}&Ssn=${ssn}`, { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }

    getallWorkstatelist(CG: any, ssn: any, ein: any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(this._sickLeaveServiceReportUrl +
            `getsickleaveworkstatebycgandssnandein?ControlGroup=${CG}&Ssn=${ssn}&Ein=${ein}`, { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }

    getallWorkcitylist(CG: any, ssn: any, ein: any, workState: any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(this._sickLeaveServiceReportUrl +
            `getsickleaveworkcitybycgandssnandeinandworkstate?ControlGroup=${CG}&Ssn=${ssn}&Ein=${ein}&WorkState=${workState}`,
            { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }

    getSickLeaveData(obj:any) {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        // if ("''" === ein) ein = '1';
        // if ("''" === workstate) workstate = '1';
        // if ("''" === workcity) workcity = '1';
        return this._http.post(this._sickLeaveServiceReportUrl +
            `v2/getsickleavedata`,obj,{headers: headers})
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    getSSnDataDetail(ssnData: any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        let fileName = 'ssnreportdata?Ssn=' + ssnData.ssn
            + '&TaxYear=' + ssnData.taxyear
            + '&ControlGroup=' + ssnData.controlgroup
            + '&ReportName=' + 'SickLeaveReport';
        return this._http.get(this._ssnUrl + fileName, { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    downloadExcelReport(CG: string, ssn: string, ein: string, workstate: string, workcity: string): any {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        if ("''" === ein) ein = '1';
        if ("''" === workstate) workstate = '1';
        if ("''" === workcity) workcity = '1';
        return this._http.get(this._sickLeaveServiceReportUrl +
            `sickleavereportexceldownload?ControlGroup=${CG}&Ssn=${ssn}&Ein=${ein}&WorkState=${workstate}&WorkCity=${workcity}`,
            { headers: headers, responseType: ResponseContentType.Blob })
            .map(
                (res) => {
                    const a = document.createElement('a');
                    document.body.appendChild(a);
                    const blob = new Blob([res.blob()], { type: 'application/zip' });
                    const downloadUrl = URL.createObjectURL(blob);
                    window.open(downloadUrl);
                })
    }
    private handleError(error: Response) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error(error);
        return Observable.throw(error.json().error || 'Failed in web api(Server error) ');
    }
}



// WEBPACK FOOTER //
// ./src/app/sick leave Report/sick.service.ts